import { doPost } from './common'

export const addressLookup = addressPayload => {
  try {
    let payload = addressPayload

    return doPost(`/address-validation/lookup`, payload)
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

export const addressValidate = async addressPayload => {
  let payload = addressPayload

  try {
    const res = await doPost(`/address-validation/valid`, payload)
    const addressSuggestion = await doPost(
      `/address-validation/lookup`,
      payload,
    )
    const isValid = await res.detail
    return {
      openSuggestionModal: !isValid,
      suggestionAddress: addressSuggestion.detail,
    }
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}
